import { render, staticRenderFns } from "./chiocetrainstra.vue?vue&type=template&id=7b4a3968&scoped=true"
import script from "./chiocetrainstra.vue?vue&type=script&lang=js"
export * from "./chiocetrainstra.vue?vue&type=script&lang=js"
import style0 from "./chiocetrainstra.vue?vue&type=style&index=0&id=7b4a3968&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4a3968",
  null
  
)

export default component.exports